var render, staticRenderFns
import script from "./TableCellNumVialsMixedPerTech.vue?vue&type=script&lang=js&"
export * from "./TableCellNumVialsMixedPerTech.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bdf39656')) {
      api.createRecord('bdf39656', component.options)
    } else {
      api.reload('bdf39656', component.options)
    }
    
  }
}
component.options.__file = "public/js/src/app/components/allergy-kpis/tracking-sheet/table-cells/TableCellNumVialsMixedPerTech.vue"
export default component.exports